import React, { useState } from 'react';
import CalciImg from '../images/Calculator image.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';

const RudrakshaCalculator = () => {
  const [formData, setFormData] = useState({
    suggestionBy: '',
    name: '',
    phone: '',
    email: '',
    dob: '',
    birthTime: '',
    unknownTime: false,
    birthPlace: '',
  });

  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let recommended = [];
    if (formData.suggestionBy === 'birth') {
      recommended = ['6 Mukhi', '13 Mukhi'];
    } else if (formData.suggestionBy === 'manifestation') {
      recommended = ['11 Mukhi', '15 Mukhi'];
    } else {
      recommended = ['3 Mukhi', '9 Mukhi'];
    }

    setResult(recommended);
  };

  return (
    <div className="py-5" style={{ backgroundColor: '#fffaf5', fontFamily: 'math' }}>
      <div className="container">
        <h1 className="mb-5 display-5 fw-bold text-center text-md-start px-2">
          <span
            style={{
              borderBottom: '3px solid #ff8051',
              display: 'inline-block',
              paddingBottom: '4px',
            }}
            className="d-inline d-md-inline border-highlight"
          >
            Rudraksha Calculator :
          </span>{' '}
          Know which Rudraksha is the key to good fortune for you as per Birth Chart
        </h1>

        <style>
          {`
            @media (max-width: 768px) {
              .border-highlight {
                border-bottom: none !important;
              }
            }
          `}
        </style>


        <div className="row g-4 align-items-center">
          {/* Form Section */}
          <div className="col-lg-6">
            <div className="card shadow p-4" style={{ backgroundColor: '#fffbf0', borderRadius: '12px', border: 'none' }}>
              <h2 className="mb-4 text-center">Lucky Rudraksha Calculator</h2>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Rudraksha Suggestion By:</label>
                  <select
                    className="form-select"
                    name="suggestionBy"
                    value={formData.suggestionBy}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Option</option>
                    <option value="birth">Birth</option>
                    <option value="manifestation">Manifestation / Luck</option>
                    <option value="purpose">Purpose</option>
                  </select>
                </div>

                <div className="row g-2 mb-3">
                  <div className="col">
                    <label className="form-label">Name:</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Phone Number:</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Email:</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="row g-2 mb-3">
                  <div className="col">
                    <label className="form-label">Date of Birth:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col">
                    <label className="form-label">Birth Time:</label>
                    <input
                      type="time"
                      className="form-control"
                      name="birthTime"
                      value={formData.birthTime}
                      onChange={handleChange}
                    />
                    <div className="form-check mt-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="unknownTime"
                        name="unknownTime"
                        checked={formData.unknownTime}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="unknownTime">
                        I don't know the birth time
                      </label>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Place of Birth:</label>
                  <input
                    type="text"
                    className="form-control"
                    name="birthPlace"
                    value={formData.birthPlace}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-primary w-100 fw-semibold rounded-pill">
                    Submit
                  </button>
                </div>
              </form>

              {/* Result Section */}
              {result && (
                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 my-4">
                  {result.map((item, index) => (
                    <div
                      key={index}
                      className="card shadow-sm"
                      style={{ width: '250px', borderRadius: '10px' }}
                    >
                      <img
                        src="https://5.imimg.com/data5/SELLER/Default/2023/7/327040345/HW/GX/TU/65828692/5-mukhi-rudraksha-500x500.JPG"
                        alt="Rudraksha"
                        className="img-fluid"
                        style={{
                          borderRadius: '10px 10px 0 0',
                          height: '180px',
                          objectFit: 'cover',
                        }}
                      />
                      <div className="p-2 text-center">
                        <h6 className="fw-bold">{item}</h6>
                        <button
                          className="btn btn-sm rounded-pill mt-2"
                          style={{ backgroundColor: '#7b0000', color: '#fff' }}
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Image Section */}
          <div className="col-lg-6">
            <img
              src={CalciImg}
              alt="Calculator"
              className="img-fluid shadow rounded"
              style={{ height: '100%', objectFit: 'cover' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RudrakshaCalculator;
